import { useMemo, useState, useEffect } from "react"

// MUI
import { Toolbar, useTheme, AppBar, Box, Divider } from "@mui/material"
import useMediaQuery from "@mui/material/useMediaQuery"

// Components
import AppBarStyled from "./appbar-styled"
import IconButton from "../../common/icon-button"
import HeaderContent from "./header-content"

// icons
import { HambergerMenu } from "iconsax-react"

// ======================================================

const Header = ({ mobileOpen, open, handleDrawerToggle }) => {
  // Use Theme
  const theme = useTheme()

  // Use State
  const [scroll, setScroll] = useState(false)

  // header content
  const headerContent = useMemo(() => <HeaderContent />, [])

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 50)
    })
  }, [])

  // common header
  const mainHeader = (
    <Toolbar sx={{ borderRadius: 1, mb: 1, background: theme.palette.mode === "dark" ? "rgba(30, 30, 30 , 0.7)" : "rgba(255, 255, 255 , 0.5)" }}>
      {headerContent}
    </Toolbar>
  )

  // app-bar params
  const appBar = {
    position: "sticky",
    top: "10px",
    color: "inherit",
    elevation: 0,
    sx: {
      background: scroll
        ? theme.palette.mode === "dark"
          ? "rgba(30, 30, 30 , 0.7)"
          : "rgba(255, 255, 255 , 0.4)"
        : "",
      backdropFilter: scroll ? "blur(0.6rem)" : "",
      ml: { md: 0, lg: 2 },
      m: 1,
      borderRadius: "12px",
      boxShadow: scroll ? theme.shadows[3] : theme.shadows[0]
    }
  }

  const matchDownMD = useMediaQuery(theme.breakpoints.down("lg"))

  return (
    <>
      {!matchDownMD ? (
        <AppBarStyled open={open} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar sx={{ px: 0 }} {...appBar}>
          {mainHeader}
        </AppBar>
      )}
    </>
  )
}

export default Header
